import { makeStyles } from '@material-ui/core';
import paleta from '../../configuraciones/paleta';

const styles = makeStyles((theme) => ({
  root: {
    marginBottom: 20,
    marginTop: -35,
  },
  paper: {
    marginTop: 2,
    color: theme.palette.text.secondary,
  },
  btnContainer: {
    flex: 1,
    maxWidth: 125,
  },
  btn: {
    maxWidth: 125,
    width: '97%',
  },
  table: {
    height: 'auto',
    maxHeight: '60vh',
    minHeight: '250px',
    borderRadius: 0,
    borderTop: 'none',
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    borderTopRightRadius: 8,
  },
  label: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  input: {
    width: '97%',
    paddingRight: 0,
    minHeight: 42,
    marginTop: 10,
    backgroundColor: paleta.textField.backgroundColor,
    borderRadius: 5,
    outline: 'none',
    padding: '0 10px',
    border: `1px solid ${paleta.textField.border}`,
    '&:hover, &:focus': {
      backgroundColor: paleta.textField.backgroundColorHover,
    },
    '&.disabled': {
      backgroundColor: paleta.textField.backgroundColorDisabled,
    },
  },
  btnAction: {
    margin: theme.spacing(0.5),
    textAlign: 'center',
  },
  datePickerInput: {
    width: '100%',
  },
  datePaper: {
    boxShadow: '0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important',
  },
  calendario: {
    backgroundColor: 'red',
  },
  textField: {
    '& > div': {
      width: '97%'
    }
  },
  toggleButtonGroup: {
    alignSelf: 'flex-end',
    marginTop: '10px',
    width: '97%',
    maxWidth: '230px',
    maxHeight: '42px'
  },
  toggleButton: {
    flex: 1,
  }
}));

export default styles;
